export const CUSTOM_MAIL_FOOTER = {
    "es-ES": `Soy un texto. \n con un intro mazo wapo`,
    "ca-ES": `Soc un text. \n amb un intro super wapo`,
    "en-US": `I am a text. \n with an enter giga biutiful`,
    "it-IT": `italiano. \n con un italienter mazo italiwapo`,
    "fr-FR": `Soy un tegsto. \n con un ingtro mazo gapo`,
}